import React, { useState } from 'react';
import {
  Box,
  TextField,
  Typography,
  Grid,
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { WithdrawalDto, Iban } from '../../../types/approval.types';
import { formatMoney, formatMoneyForTable, currencyToForm } from '../../../utils/approvalUtils';

interface WithdrawalCancelDetailProps {
  data: WithdrawalDto;
  iban: Iban;
  rejectionReason: string;
  onReasonChange: (reason: string) => void;
  onSubmit: () => void;
  isLoading: boolean;
}

const WithdrawalCancelDetail: React.FC<WithdrawalCancelDetailProps> = ({
  data,
  iban,
  rejectionReason,
  onReasonChange,
  onSubmit,
  isLoading
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!data || !iban) {
    return (
      <Box sx={{ padding: 2 }}>
        <Typography variant="h6">Detaylar yüklenemedi.</Typography>
      </Box>
    );
  }

  return (
    <Box>
      <Accordion expanded={isExpanded} onChange={() => setIsExpanded(!isExpanded)}>
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Typography variant="subtitle1">İşlem Detayı</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Alıcı IBAN"
                value={iban.receiverIBAN}
                disabled
                variant="outlined"
                size="small"
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Tutar"
                value={formatMoneyForTable(data.Data.Value, currencyToForm(data.Data.CurrencyId))}
                disabled
                variant="outlined"
                size="small"
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Para Birimi"
                value={currencyToForm(data.Data.CurrencyId)}
                disabled
                variant="outlined"
                size="small"
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Komisyon"
                value={formatMoney(data.Data.ValueFee)}
                disabled
                variant="outlined"
                size="small"
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Toplam"
                value={formatMoney(data.Data.Value + data.Data.ValueFee)}
                disabled
                variant="outlined"
                size="small"
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Açıklama"
                value={data.Data.Description}
                disabled
                variant="outlined"
                size="small"
                multiline
                rows={3}
              />
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>

      <Box sx={{ mt: 3 }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="İptal Nedeni"
              value={rejectionReason}
              onChange={(e) => onReasonChange(e.target.value)}
              variant="outlined"
              size="small"
              required
              error={!rejectionReason.trim()}
              helperText={!rejectionReason.trim() ? 'Lütfen iptal nedenini giriniz' : ''}
            />
          </Grid>

          {/* <Grid item xs={12}>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                variant="contained"
                color="error"
                onClick={onSubmit}
                disabled={!rejectionReason.trim() || isLoading}
              >
                İptal
              </Button>
            </Box>
          </Grid> */}
        </Grid>
      </Box>
    </Box>
  );
};

export default WithdrawalCancelDetail;
